export function isPre (separation)
{
	return separation && separation.type.includes('pre');
}

export function isPost (separation)
{
	return separation && separation.type.includes('post');
}
